"use client";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { Textarea } from "@/components/ui/textarea";

type ChatFeedbackDialogProps = {
  open: boolean;
  note: string;
  consentToReadChat: boolean;
  isSubmitting: boolean;
  onConsentToReadChatChange: (value: boolean) => void;
  onNoteChange: (value: string) => void;
  onOpenChange: (open: boolean) => void;
  onSubmit: () => void;
};

export const ChatFeedbackDialog = ({
  open,
  note,
  consentToReadChat,
  isSubmitting,
  onConsentToReadChatChange,
  onNoteChange,
  onOpenChange,
  onSubmit,
}: ChatFeedbackDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-xl">
      <DialogHeader>
        <DialogTitle>Negative feedback</DialogTitle>
        <DialogDescription>
          Tell us what went wrong with this chat response.
        </DialogDescription>
      </DialogHeader>

      <div className="space-y-5">
        <div className="space-y-2">
          <p className="text-sm font-medium text-foreground">What happened?</p>
          <Textarea
            className="min-h-32"
            disabled={isSubmitting}
            onChange={(event) => onNoteChange(event.currentTarget.value)}
            placeholder="Briefly describe the issue."
            value={note}
          />
        </div>

        <div className="rounded-2xl border border-border bg-muted/40 p-4">
          <div className="flex items-start justify-between gap-4">
            <div className="space-y-1">
              <p className="text-sm font-medium text-foreground">
                Allow review of this chat
              </p>
              <p className="text-sm text-muted-foreground">
                Lets the team inspect this conversation alongside your feedback.
              </p>
            </div>
            <Switch
              checked={consentToReadChat}
              disabled={isSubmitting}
              onCheckedChange={onConsentToReadChatChange}
            />
          </div>
        </div>
      </div>

      <DialogFooter>
        <Button
          disabled={isSubmitting}
          onClick={() => onOpenChange(false)}
          type="button"
          variant="outline"
        >
          Cancel
        </Button>
        <Button
          disabled={isSubmitting || !note.trim()}
          onClick={onSubmit}
          type="button"
        >
          {isSubmitting ? "Sending..." : "Send"}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);